// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var AccountContactInformationType;
(function (AccountContactInformationType) {
    AccountContactInformationType[AccountContactInformationType["UNKNOWN"] = 0] = "UNKNOWN";
    AccountContactInformationType[AccountContactInformationType["PHONE"] = 1] = "PHONE";
    AccountContactInformationType[AccountContactInformationType["MOBILE"] = 2] = "MOBILE";
    AccountContactInformationType[AccountContactInformationType["FAX"] = 3] = "FAX";
    AccountContactInformationType[AccountContactInformationType["WEB"] = 4] = "WEB";
    AccountContactInformationType[AccountContactInformationType["EMAIL"] = 5] = "EMAIL";
    AccountContactInformationType[AccountContactInformationType["DONOTCALL"] = 6] = "DONOTCALL";
    AccountContactInformationType[AccountContactInformationType["FACEBOOK"] = 7] = "FACEBOOK";
    AccountContactInformationType[AccountContactInformationType["TWITTER"] = 8] = "TWITTER";
    AccountContactInformationType[AccountContactInformationType["LINKEDIN"] = 9] = "LINKEDIN";
    AccountContactInformationType[AccountContactInformationType["GOOGLEPLUS"] = 10] = "GOOGLEPLUS";
    AccountContactInformationType[AccountContactInformationType["YOUTUBE"] = 11] = "YOUTUBE";
    AccountContactInformationType[AccountContactInformationType["Text"] = 12] = "Text";
    AccountContactInformationType[AccountContactInformationType["Mail"] = 13] = "Mail";
    AccountContactInformationType[AccountContactInformationType["MANGO"] = 14] = "MANGO";
})(AccountContactInformationType || (AccountContactInformationType = {}));
//# sourceMappingURL=accountContactInformationType.js.map